// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3-eQU","label":"SetPasswdForm_label__2GqjJ"};